/**
 * @example getInitials('John Michael Doe') returns 'JD'
 * @returns the first letter of the first and last name in upper case
 */
export function getInitials(name: string): string {
  if(!name || !name.length) {
    return ''
  }
  const nameArr: string[] = name.split(' ');
  let initials = nameArr[0].substring(0, 1).toUpperCase();

  if (nameArr.length > 1) {
    initials += nameArr[nameArr.length - 1].substring(0, 1).toUpperCase();
  }
  return initials;
}